module.exports = __webpack_public_path__ + "img/135.eb5aed76.svg";